import React from 'react';
import classname from 'classnames';

import { TextField } from '@BICE_Vida/components';

import styles from './TextFieldStatus.module.scss';

type TextFieldStatusT = {
  id?: string;
  label?: string;
  placeholder?: string;
  showPlaceholder?: boolean;
  value: number | string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  className?: string;
  hasError?: boolean;
  feedback?: string;
  disabled?: boolean;
  type?: string;
  pattern?: string;
  helperText?: string;
  showCounter?: boolean;
  maxLength?: number;
  icon?: string;
  iconClassName?: string;
  loading?: boolean;
  warning?: boolean;
  children?: any;
};

const TextFieldStatus = ({
  id,
  label,
  placeholder,
  showPlaceholder,
  value,
  onChange,
  onBlur,
  onKeyPress,
  className,
  hasError,
  feedback,
  disabled,
  type,
  pattern,
  helperText,
  showCounter,
  maxLength,
  icon,
  iconClassName,
  children,
  loading,
  warning,
  ...props
}: TextFieldStatusT) => {
  const iconClasses = classname({
    [`${iconClassName}`]: iconClassName,
    [styles.form_input_warning]: warning,
    [styles.form_input_loader_icon]: loading,
  });

  const inputClasses = classname({
    [`${className}`]: className,
    [styles.form_warning_input]: warning,
  });

  return (
    <TextField
      id={id}
      className={inputClasses}
      label={label}
      placeholder={placeholder}
      showPlaceholder={showPlaceholder}
      value={value}
      onChange={onChange}
      onKeyPress={onKeyPress}
      onBlur={onBlur}
      hasError={hasError}
      feedback={feedback}
      icon={loading ? 'circle' : warning ? 'warning' : icon}
      iconClassName={iconClasses}
      {...{
        ...props,
      }}
      disabled={disabled}
      type={type}
      pattern={pattern}
      helperText={helperText}
      showCounter={showCounter}
      maxLength={maxLength}
    >
      {children}
    </TextField>
  );
};

export default TextFieldStatus;
